module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-E-patch.d6d549d5.png";